export const BUSINESS_DETAILS_SLICE_NAME = "businessDetails"
